
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"35","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.333 6.5a1 1 0 0 1 1-1h10.5a1 1 0 1 1 0 2h-9.5v19h3.834v-6a1 1 0 0 1 1-1h4.666a1 1 0 0 1 1 1v6h3.834V14.667a1 1 0 1 1 2 0V26.5H28a1 1 0 1 1 0 2H7a1 1 0 1 1 0-2h1.333v-20Zm7.834 20h2.666v-5h-2.666v5ZM13 11.167a1 1 0 0 1 1-1h1.167a1 1 0 1 1 0 2H14a1 1 0 0 1-1-1Zm6.833-1a1 1 0 1 0 0 2H21a1 1 0 1 0 0-2h-1.167Zm-1 5.666a1 1 0 0 1 1-1H21a1 1 0 1 1 0 2h-1.167a1 1 0 0 1-1-1Zm-4.833-1a1 1 0 1 0 0 2h1.167a1 1 0 1 0 0-2H14Z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M26.47 3.781a.4.4 0 0 1 .726 0l.866 1.864a.4.4 0 0 0 .314.229l2.04.247a.4.4 0 0 1 .225.69l-1.505 1.4a.4.4 0 0 0-.12.37l.395 2.016a.4.4 0 0 1-.587.426l-1.796-.999a.4.4 0 0 0-.39 0l-1.795 1a.4.4 0 0 1-.587-.427l.395-2.017a.4.4 0 0 0-.12-.37l-1.505-1.399a.4.4 0 0 1 .224-.69l2.04-.247a.4.4 0 0 0 .315-.229l.866-1.864Z","fill":"url(#a)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"a","x1":"22.167","y1":"3","x2":"32.537","y2":"4.346","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#C67702"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#E0A12A"}})])])])
          )
        }
      }
    